export default __webpack_public_path__ + "68f246e3c0e7bb14875d68b273960cf5.svg";